import { useEffect, useState } from "react";

/**
 * Хук, проверяющий заблокирован ли пользователь и на сколько времени
 * Хук может вызываться только на форме ввода телефона
 */
export const useIsUserBlocked = () => {
  const [isUserBlocked, setIsUserBlocked] = useState(false);
  const [timeBlock, setTimeBlock] = useState<number | null>(null);

  useEffect(() => {
    const match = window.error?.match(/phoneRegBlocked(\d+)/);
    if (match && match[1]) {
      setIsUserBlocked(true);
      setTimeBlock(Number(match[1]));
    } else {
      setIsUserBlocked(false);
      setTimeBlock(null);
    }
  }, [window.error]);

  return {
    isUserBlocked,
    timeBlock,
  };
};
